import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/Brands/Handlers/LoadBrandsAlphabet";
import { BrandAlphabetModel } from "@insite/client-framework/Types/ApiModels";
import { getBrandAlphabet } from "@tCentro/Services/BrandServiceExtension";

type HandlerType = HandlerWithResult<
    {},
    {
        apiResult: BrandAlphabetModel;
    },
    {}
>;

export const RequestDataFromApiExtended: HandlerType = async props => {
    props.result = {
        apiResult: await getBrandAlphabet(),
    };
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiExtended);